import { useTranslation } from 'react-i18next';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { INFLUENCER_STATUS_OPTIONS } from '@anytag/shared-constants';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const InfluencerStatusField = (props: Omit<SingleSelectorFieldProps<InfluencersFilterFormKeys>, 'name'>) => {
  const { t } = useTranslation();
  const statusesOptions = useTranslateOptions(INFLUENCER_STATUS_OPTIONS);

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="status"
      options={statusesOptions}
      title={t('Selector.Influencer Status')}
      {...props}
    />
  );
};
